import React from 'react';

const ExpressBadge = ({ express = false, className = '' }) => {
  if (!express) {
    return (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${className}`}
            style={{ backgroundColor: '#E8E8E8', color: '#666666' }}>
        Standard
      </span>
    );
  }

  return (
    <span className={`badge-express ${className}`}>
      Express 60'
    </span>
  );
};

export default ExpressBadge;
